import { CancelToken } from 'axios';
import { siteAxios } from '.';
import { get } from '~/App/helpers/cookie';
import { logSimpleMessage } from '../logger';
import { IPurchaseShow } from '~/types/IPurchaseShow';
import { getListPrice } from '../purchase-helper';

type PurchasesShowArguments = {
  slug: string;
  cancelToken?: CancelToken;
  params?: Record<string, unknown>;
};

type PurchasesShowSocialArguments = {
  publicToken: string;
};

type PurchasesSocialArguments = {
  publicToken: string;
  data: Record<string, unknown>;
};

type PurchasesCreateArguments = {
  data: any;
};

export const purchases = {
  show: ({ slug, params }: PurchasesShowArguments) => {
    logSimpleMessage(`Fetching purchase ${slug}`);

    return siteAxios.get<IPurchaseShow>(`/api/v2/mw/purchases/${slug}`, {
      params
    });
  },
  showSocial: ({ publicToken }: PurchasesShowSocialArguments) => {
    return siteAxios.get(`/api/v2/mw/purchases/${publicToken}/social`);
  },
  social: ({ publicToken, data }: PurchasesSocialArguments) =>
    siteAxios({
      url: `/api/v2/mw/purchases/${publicToken}/social`,
      method: 'post',
      headers: {
        'X-Session-Key': get('secretKey')
      },
      data: {
        ...data
      }
    }),
  create: ({ data }: PurchasesCreateArguments) => {
    const price = getListPrice(data.productOptions);
    const clientId = data?.clientOptions?.clientId;
    const productId = data?.product?.id;

    logSimpleMessage(
      `Creating purchase (${productId}: ${price} kr) from client id ${clientId}`
    );

    return siteAxios({
      url: `/api/v2/mw/purchases`,
      method: 'post',
      headers: {
        'X-Session-Key': get('secretKey')
      },
      data: {
        purchase: {
          ...data
        }
      }
    });
  }
};
